import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserApplicationPort } from '../../../application/user/port/user-application.port';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
	constructor(private _userApplicationPort: UserApplicationPort) {}

	public canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		return this._userApplicationPort
			.observeSessionUser()
			.pipe(map((user) => !!user));
	}
}
